import Vue from "vue";
import {VueMasonryPlugin} from 'vue-masonry';

Vue.use(VueMasonryPlugin)

export default VueMasonryPlugin;